<template>

    <!-- 
        Шапка картки завдання
    -->
    
    <div class="row" >
        <div class="col-lg-12" >
            <div class="card mt-n4 mx-n3" >
                <div class="bg-soft-info" >
                    <div class="card-body pb-0 px-4" >
                        <div class="row mb-3" >
                            <div class="col-md" >
                                <div class="row align-items-center g-3" >
                                    <!-- <div class="col-md-auto" >
                                        <div class="avatar-md" >
                                            <div class="avatar-title bg-white rounded-circle" >
                                                <img src="assets/images/brands/slack.png" alt="" class="avatar-xs">
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="col-md" >
                                        <div >
                                            <h4 class="fw-bold">{{ form.title }}</h4>
                                            <div class="hstack gap-3 flex-wrap" >
                                                <div >{{ $t('project') }}: <strong>{{ form.problemEnvironment }}</strong></div>
                                                <div class="vr" ></div>
                                                <div >{{ $t('createDate') }}: <span class="fw-semibold">{{ formatDateTime(form.createDatetime) }}</span></div>
                                                <div class="vr" ></div>
                                                <div >{{ $t('Deadline') }}: <span class="fw-semibold">{{ form.deadlineDatetime == "" ? $t('NotDefined') : formatDateTime(form.deadlineDatetime) }}</span></div>
                                                <div class="vr" ></div>
                                                <div :class="`badge rounded-pill bg-${this.mutatestatus(form.status).color} fs-12`" >{{ this.mutatestatus(form.status).name }}</div>
                                                <div :class="`badge rounded-pill bg-${this.mutatepriority(form.priority).color} fs-12`" >{{ this.mutatepriority(form.priority).name }}</div>
                                                <!-- <div class="badge rounded-pill bg-danger fs-12" >{{ form.priority }}</div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ul class="nav nav-tabs-custom border-bottom-0" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link fw-semibold active" data-bs-toggle="tab" href="#testing-main" role="tab" aria-selected="true">
                                    {{ $t('main') }}
                                </a>
                            </li>
                            <!-- <li class="nav-item" role="presentation">
                                <a class="nav-link fw-semibold" data-bs-toggle="tab" href="#testing-devices" role="tab" aria-selected="false" tabindex="-1">
                                    Пристрої
                                </a>
                            </li> -->
                            <li class="nav-item" role="presentation">
                                <a class="nav-link fw-semibold" data-bs-toggle="tab" href="#testing-chat" role="tab" aria-selected="false" tabindex="-1">
                                    {{ $t('chat') }}
                                </a>
                            </li>
                            <li v-if="form.testingPlan == 'checklist'" class="nav-item" role="presentation">
                                <a class="nav-link fw-semibold" data-bs-toggle="tab" href="#testing-checklist" role="tab" aria-selected="false" tabindex="-1">
                                    {{ $t('Checklist') }}
                                </a>
                            </li>
                            <li v-if="form.testingPlan == 'testcases'" class="nav-item" role="presentation">
                                <a class="nav-link fw-semibold" data-bs-toggle="tab" href="#testing-testcases" role="tab" aria-selected="false" tabindex="-1">
                                    {{ $t('TestCases') }}
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link fw-semibold" data-bs-toggle="tab" href="#testing-reports" role="tab" aria-selected="false" tabindex="-1">
                                    {{ $t('BugReports') }}
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link fw-semibold" data-bs-toggle="tab" href="#testing-files" role="tab" aria-selected="false" tabindex="-1">
                                    {{ $t('Files') }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { 
        mutateStatusTicket,
        mutatePriorityTicket
      } from '@/usabilityScripts/globalMutate.js'


export default {
    props: ['objCard'],
    components: {

    },
    data() {
        return {
            form: ''
        }
    },
    created(){
        this.getdata();
    },
    methods: {
        getdata(){
            this.form = this.objCard
        },
        mutatepriority(e){
            // мутейт пріорітету
            return mutatePriorityTicket(e)
        },
        mutatestatus(e){
            // мутейт статусу
            return mutateStatusTicket(e)
        },
        formatDateTime(dateTimeString){
            const months = [
                "січня", "лютого", "березня", "квітня", "травня", "червня",
                "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"
            ];
            const date = new Date(dateTimeString);
            const day = date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");

            return `${day} ${month}, ${year}`;
        },
    }
}
</script>
